<template>
  <div style="padding-top:19px;padding-left:30px">
    <div
      style="display:flex;align-items: center;position: relative;"
      v-for="(item, index) in data"
      :key="index"
    >
      <div class="material">
        <span class="material_name">
          <a-tooltip>
            <template slot="title">{{ item.rawMaterial.name }}</template>
            {{ item.rawMaterial.name }}
          </a-tooltip>
        </span>
        <!-- <span class="material_name">{{ item.rawMaterial.name }}</span> -->
        <span>{{ item.weight + "kg" }}</span>
      </div>
      <div class="border"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
}
</script>

<style scoped>
.material {
  display: flex;
  height: 30px;
  padding-left: 65px;
  width: calc(100% - 55px);
}
.material span {
  flex: 1;
}
.material_name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.border {
  width: 55px;
  height: 30px;
  border-left: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  position: absolute;
  top: -19px;
}
</style>
